import { Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from '../demo/service/auth.service';
import { ManageAccountService } from '../demo/service/admin/manageaccount.service';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { WastemastermanageService } from '../demo/service/admin/wastemastermanage.service';
import { DisposermanageService } from '../demo/service/admin/disposermanage.service';
import { ROLES } from '../demo/constants/roles.constant';
import { map, Subject, Subscription, takeUntil } from 'rxjs';
import { Notifications } from '../demo/api/notification';
import { NotificationService } from '../demo/service/notification.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit {
    isAdmin: boolean = false;
    isDisposer: boolean = false;
    loadingNoti: boolean = true;
    
    displayChangeEmail: boolean = false;
    displayChangePassword: boolean = false;
    displayChangeRole: boolean = false;
    showNotificationPanel: boolean = false;
    
    emailForm: FormGroup;
    passwordForm: FormGroup;
    roleForm: FormGroup;
    
    items!: MenuItem[];
    menuItems!: MenuItem[];
    disposerDropdownData: any[] = [];
    loading: boolean = true;
    
    userInfo: string | null = null;
    
    cards: Notifications[] = [];
    notificationData: any[];
    notificationsNum: number = 0;
    
    private subscriptions = new Subscription();
    
    $onDestroy: Subject<void> = new Subject<void>();
    
    
    @ViewChild('menubutton') menuButton!: ElementRef;
    
    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
    
    @ViewChild('topbarmenu') menu!: ElementRef;
    
    @ViewChild('notificationBox') notificationBox: ElementRef;

    constructor(public layoutService: LayoutService, private authService: AuthService, private accountService: ManageAccountService, private messageService: MessageService, private fb: FormBuilder,
        private disposerService: DisposermanageService, private notificationService: NotificationService,
        private renderer: Renderer2,
    ) {
        this.isAdmin = this.authService.getRoleId() === ROLES.ADMIN;

        this.isDisposer = this.authService.getRoleId() === ROLES.DISPOSER;

        this.initializeMenuItems();

        this.emailForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });

        this.passwordForm = this.fb.group({
            oldPassword: ['', Validators.required],
            newPassword: ['', Validators.required],
            confirmNewPassword: ['', Validators.required]
        });

        this.roleForm = this.fb.group({
            disposerId: ['', Validators.required],
        })

        let data = localStorage.getItem('access_token');

        // this.notificationService.startConnection(data);
        // this.notificationService.addNotificationListener();
        this.notificationService.loadNotificationCount();
        this.notificationService.notificationsCount$.subscribe((count) => {
            this.notificationsNum = count;
            this.loadingNoti = false;
          });
    }


    ngOnInit(): void {
        // setTimeout(() => this.loading = false, 3000);
        const username = this.authService.getUsername();
        const roleName = this.authService.getRoleName();
        this.userInfo = `${username ?? ''} ${roleName ?? ''}`;
        // this.loadNotification()
        // this.loadNotificationCount();
    }

    get badgeValue(): string {
        return this.notificationsNum > 99 ? '99+' : this.notificationsNum.toString();
    }

    initializeMenuItems() {
        this.menuItems = [
            {
                label: 'Change Email', icon: 'fa fa-at', command: () => { this.showDialog('email'); }
            },
            {
                label: 'Change Password', icon: 'fa fa-key', command: () => { this.showDialog('password'); }
            }
        ];

        if (this.isAdmin) {
            this.menuItems.push({
                label: 'Change Role', icon: 'pi pi-sync', command: () => { this.showDialog('role'); }
            });
        }
    }


    loadDisposerDropdown(): void {
        this.disposerService.getAllDisposer().subscribe({
            next: (data) => {
                this.disposerDropdownData = [{ label: 'ADMIN', value: 0 }, ...data.map(item => ({ label: item.disposerName, value: item.disposerId }))];
                console.log(this.disposerDropdownData);
            },
            error: (error) => {
                console.error('Error fetching DisposersGroup', error);
            }
        });
    }

    logout() {
        this.notificationService.stopConnection();
        this.authService.logout()
    }

    showDialog(type: string) {
        if (type === 'email') {
            this.displayChangeEmail = true;
        } else if (type === 'password') {
            this.displayChangePassword = true;
        } else if (type === 'role') {
            this.displayChangeRole = true;
            this.loadDisposerDropdown();
        }
    }

    passwordMatchValidator(formGroup: AbstractControl) {
        const newPassword = formGroup.get('newPassword')!.value;
        const confirmNewPassword = formGroup.get('confirmNewPassword')!.value;

        if (confirmNewPassword !== newPassword) {
            return { mismatch: true }; // If confirm password is empty, show mismatch error
        }
        return newPassword === confirmNewPassword ? null : { mismatch: true };
    }

    onSubmitEmail() {
        if (this.emailForm.valid) {
            const userData = {
                id: this.authService.getUserId(),
                email: this.emailForm.get('email').value,
            };

            this.accountService.changeEmail(userData).subscribe({
                next: response => {
                    console.log('Email change successful', response);
                    this.messageService.add({ severity: 'success', summary: 'Update Email Success', detail: 'Email updated successfully' });
                    this.displayChangeEmail = false;
                },
                error: (error: HttpErrorResponse) => {
                    console.error('Error changing email', error);
                    this.messageService.add({ severity: 'error', summary: 'Change Email Failed', detail: error.error });
                }
            });
        }
    }

    onCancelEmail() {
        this.emailForm.reset();
        this.displayChangeEmail = false;
    }

    onSubmitPassword() {
        if (this.passwordForm.valid) {
            const passwordData = {
                id: this.authService.getUserId(),
                oldPassword: this.passwordForm.get('oldPassword').value,
                password: this.passwordForm.get('newPassword').value,
                confirmPassword: this.passwordForm.get('confirmNewPassword').value
            };

            this.accountService.changeOwnPassword(passwordData).subscribe({
                next: response => {
                    console.log('Password change successful', response);
                    this.messageService.add({ severity: 'success', summary: 'Update Password Success', detail: 'Password updated successfully' });
                    this.displayChangePassword = false;
                },
                error: (error: HttpErrorResponse) => {
                    console.error('Error changing password', error);
                    this.messageService.add({ severity: 'error', summary: 'Change Password Failed', detail: error.error });
                }
            });
        }
    }

    onCancelPassword() {
        this.passwordForm.reset();
        this.displayChangePassword = false;
    }

    onSubmitChangeRole() {
        if (this.roleForm.valid) {
            let userId = this.authService.getUserId();
            let disposerId = this.roleForm.get('disposerId').value;
            this.authService.changeRole(userId, disposerId).subscribe({
                next: (data) => {
                    this.messageService.add({ severity: 'success', summary: 'Change Role Success', detail: 'Change Role successfully' });
                    const username = this.authService.getUsername();
                    const roleName = this.authService.getRoleName();
                    this.userInfo = `${username ?? ''} ${roleName ?? ''}`;
                    location.reload();
                },
                error: (error) => {
                    console.log(error);
                    this.messageService.add({ severity: 'error', summary: 'Change Role Failed', detail: error.error });
                }
            })
        }
    }

    onCancelChangeRole() {
        this.displayChangeRole = false;
        this.roleForm.reset();
    }

    loadNotification() {
        if (!this.showNotificationPanel) {
            this.loadingNoti = true;
            this.notificationService.getNotification().subscribe({
                next: response => {
                    this.notificationService.loadNotificationCount();
                    this.notificationData = response;
                    console.log('Noti', this.notificationData);
                    this.showNotificationPanel = true;
                    this.loadingNoti = false;

                    this.renderer.listen('window', 'click', (e: Event) => {
                        if (this.notificationBox && !this.notificationBox.nativeElement.contains(e.target)) {
                          this.showNotificationPanel = false; // Close notification if click is outside
                        }
                    });
                },
                error: error => {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
                }
            })
        } else {
            this.showNotificationPanel = false;
        }
    }

    loadNotificationCount() {
        this.notificationService.getNotificationCount().subscribe({
            next: response => {
                console.log('Noti', response);
                this.notificationsNum = response;
                this.loadingNoti = false;
            },
            error: error => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
            }
        })
    }

    toggleNotifications() {
        this.showNotificationPanel = !this.showNotificationPanel;
    }

    handleNotificationClick(noti: any) {
        this.notificationService.readNotification(noti.id).subscribe({
            next: response => {
                if (noti.isLink) {
                    window.open(noti.url, '_blank');
                }
                this.notificationService.loadNotificationCount();
                this.showNotificationPanel = false;
                this.loadNotification();
            },
            error: error => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
            }
        })
    }

    deleteNotification(noti: any) {
        this.notificationService.deleteNotification(noti.id).subscribe({
            next: response => {
                this.notificationService.loadNotificationCount();
                this.showNotificationPanel = false;
                this.loadNotification();
            },
            error: error => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.error}` });
            }
        })
    }

    read() {
        this.cards.forEach(card => {
            if (!card.status) {
                this.layoutService.markNotificationAsRead(card);
            }
        });
        this.notificationsNum = 0;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
